import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M109-120q-11 0-20-5.5T75-140t-5.5-19.5T75-180l370-640q6-10 15.5-15t19.5-5 19.5 5 15.5 15l370 640q6 10 5.5 20.5T885-140t-14 14.5-20 5.5zm69-80h604L480-720zm302-40q17 0 28.5-11.5T520-280t-11.5-28.5T480-320t-28.5 11.5T440-280t11.5 28.5T480-240m0-120q17 0 28.5-11.5T520-400v-120q0-17-11.5-28.5T480-560t-28.5 11.5T440-520v120q0 17 11.5 28.5T480-360m0-100" }, null, -1)
  ])))
}
export default { render: render }